import React, { Component } from "react";
import * as firebasedb from "../firebase/firebase";

class DeckOptions extends Component {

  constructor(props, context) {
    super(props, context);

    this.state = {
      dgdecks: []
    }

  this.stateupdate = this.stateupdate.bind(this);

  }

  componentDidMount () {
    var decklist = this.state.dgdecks;
    var thethis = this;

    firebasedb.db.collection("deckDetails").get().then(function(querySnapshot) {
      querySnapshot.forEach(function(doc) {
        decklist.push(
          {"id": doc.id,
          "deckName": doc.data().deckName,
          "author": doc.data().author
        });

          // doc.data() is never undefined for query doc snapshots
      //    console.log(doc.id, " => ", doc.data());
      });
      thethis.stateupdate(decklist);
    });
  }

  stateupdate(data){
    this.setState({dgdecks: data})
  }

  render() {

  var dgrdecks = this.state.dgdecks;
    return (
      dgrdecks.map(function(dgrDeck, i){
        return (
          <option value={dgrDeck.id}>{dgrDeck.deckName + " - " + dgrDeck.author}</option>
        )
      })
    );
  }
}

export default DeckOptions;



// WEBPACK FOOTER //
// ./src/Tournaments/DeckOptions.js